import {
  SeverityLevel,
  captureException,
  captureMessage,
  withScope,
} from '@sentry/browser';
import { isDev, isTest } from 'config/env';

export type LogException = (
  error: Error,
  message?: string,
  extraData?: Record<string, string>
) => void;

const logException =
  (level: SeverityLevel): LogException =>
    (error, message, extraData) => {
      if (isTest()) return;
      console.error(error, message, extraData);
      if (isDev()) return;
      withScope((scope) => {
        scope.setExtras({ ...extraData, message });
        scope.setLevel(level);
        captureException(error);
      });
    };

export const logWarning = logException('warning');

export const logError = logException('error');

export type Log = (message: string, extraData?: Record<string, string>) => void;

const log =
  (level: SeverityLevel = 'log'): Log =>
    (message, extraData?) => {
      if (isTest()) return;
      console.log(message, extraData);
      if (isDev()) return;
      withScope((scope) => {
        scope.setExtras({ ...extraData });
        captureMessage(message, level);
      });
    };

export const logInfo = log('info');

export const logDebug = log('debug');
